/**
 * Scan feedback: a short beep (WebAudio, no asset to cache) and a vibration where supported.
 * Both are best-effort and silent on failure — never block a scan on feedback.
 */
let ctx: AudioContext | null = null

function audio(): AudioContext | null {
  if (typeof window === 'undefined') return null
  const Ctor =
    window.AudioContext ??
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
  if (!Ctor) return null
  ctx ??= new Ctor()
  return ctx
}

export function beep(kind: 'ok' | 'error' = 'ok'): void {
  try {
    const ac = audio()
    if (!ac) return
    if (ac.state === 'suspended') void ac.resume()
    const osc = ac.createOscillator()
    const gain = ac.createGain()
    osc.type = 'sine'
    osc.frequency.value = kind === 'ok' ? 1046 : 220
    gain.gain.setValueAtTime(0.0001, ac.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.25, ac.currentTime + 0.01)
    gain.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + (kind === 'ok' ? 0.12 : 0.3))
    osc.connect(gain).connect(ac.destination)
    osc.start()
    osc.stop(ac.currentTime + (kind === 'ok' ? 0.13 : 0.32))
  } catch {
    /* best effort */
  }
}

export function vibrate(pattern: number | number[] = 60): void {
  try {
    navigator.vibrate?.(pattern)
  } catch {
    /* best effort */
  }
}

export function scanSuccess(): void {
  beep('ok')
  vibrate(50)
}

export function scanFailure(): void {
  beep('error')
  vibrate([80, 60, 80])
}
